import React from "react";
import { FormControl, Table } from "react-bootstrap"
import CurrencyInput from "react-currency-input"
import LoadingContainer from "../../../../_components/LoadingContainer"
import LoadingInput from "../../../../_components/LoadingInput"
import Text from "../../../../_components/Text"
import { getIPI, createIPI, updateIPI } from "../../../../api/products/taxes"
import { CSTData } from "./Template"
import Modal from "../../../../_components/Modal";
import { showSnackBar } from "../../../../utils";
import Button from "../../../../_components/Button";
import TableData from "../../../../_components/TableData";

export default props => {
    const [loading, setLoading] = React.useState(true)
    const [template, setTemplateData] = React.useState({ cst: 99, c_enq: '999', p_icms: 0, calculo: 0 })
    const [show, setShow] = React.useState(false)
    const [requesting, setRequesting] = React.useState(false)
    const [data, setData] = React.useState([])
    const ref = React.useRef(null)

    function onChange(e) {
        setTemplateData({
            ...template,
            [e.target.name]: e.target.value
        })
    }
    function closeModal() {
        if (requesting) {
            return
        }
        setShow(false)
    }
    function editItem(item) {
        setTemplateData({ ...item })
        setShow(true)
    }
    function onSubmit(e) {
        e.preventDefault()
        if (!template.name) {
            showSnackBar("Informe a descrição do modelo")
            try { document.querySelector('[name="name"]').focus() } catch (error) { }
            return
        }
        if (!template.c_enq) {
            showSnackBar(`Informe o Código Enquadramento IPI`)
            try { document.querySelector('[name="c_enq"]').focus() } catch (error) { }
            return
        }

        const request = template.id ? updateIPI : createIPI

        setRequesting(true)

        request(template)
            .then(() => {
                showSnackBar("IPI Salvo", "info")
                setTimeout(() => window.location.reload(), 1500)
            })
            .finally(() => {
                setTimeout(() => setRequesting(false), 3000)
            })
    }

    function init() {
        getIPI()
            .then(resp => {
                resp = resp.map(ipi => {
                    return {
                        ...ipi,
                        "edit": <Button onClick={() => editItem(ipi)} as="text"><i className="fas fa-edit"></i></Button>
                    }
                })
                setData(resp)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    React.useEffect(init, [ref.current])

    return <div className="container">
        <div className="row">
            <div className="col-12 py-3">
                <Text className="text-center" as="h1">
                    Modelos de IPI
                </Text>
                <div className="d-flex justify-content-center my-3">
                    <Button as="text" onClick={() => setShow(true)}>
                        Criar novo modelo
                    </Button>
                </div>
                {
                    data.length > 0
                        ? <LoadingContainer loading={loading}>
                            <TableData
                                data={data}
                                tHead={["Descrição", "CST", "Cód. Enquadramento", "Alíquota (%)", "Ações"]}
                                tBodyKeys={["name", "cst", "c_enq", "p_ipi", "edit"]}
                            />
                        </LoadingContainer>
                        : <React.Fragment />
                }
            </div>
        </div>
        <Modal title="Cadastrar modelo de IPI" show={show} onHide={closeModal}>
            <form onSubmit={onSubmit}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Nome/descrição do modelo
                                    </Text>
                                </div>
                                <LoadingInput
                                    maxLength={100}
                                    loading={requesting}
                                    onChange={onChange}
                                    value={template.name}
                                    name="name" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        CST
                                    </Text>
                                </div>
                                <LoadingInput
                                    as="select"
                                    loading={requesting}
                                    onChange={onChange}
                                    name="cst">
                                    <option selected disabled>
                                        Selecione o CST
                                    </option>
                                    {
                                        CSTData.map(item => {
                                            return <option
                                                selected={template.cst == item.code}
                                                value={item.code}
                                                key={`item-cst-ipi-select-${item.code}`} >
                                                {item.code}= {item.description}
                                            </option>
                                        })
                                    }
                                </LoadingInput>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Código Enquadramento IPI
                                    </Text>
                                </div>
                                <LoadingInput
                                    name="c_enq"
                                    loading={requesting}
                                    onChange={onChange}
                                    maxLength={5}
                                    value={template.c_enq} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Alíquota do IPI
                                    </Text>
                                </div>
                                <CurrencyInput
                                    disabled={requesting}
                                    required={true}
                                    name="p_ipi"
                                    value={template.p_ipi}
                                    onChange={(e, value, b) => onChange({ target: { name: "p_ipi", value } })}
                                    suffix=" %"
                                    className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-start">
                                <Button disabled={requesting} onClick={onSubmit}>
                                    Salvar modelo de IPI
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Modal>
    </div>
}

export function SelectIPI(props) {
    const ref = React.useRef(null)
    const [data, setData] = React.useState([])
    const [loading, setLoading] = React.useState(true)

    function onChange(e) {
        if (props.onChange) {
            props.onChange(data.filter(ipi => ipi.id === e.target.value)[0])
        }
    }

    function init() {
        getIPI()
            .then(data => setData(data))
            .finally(() => setLoading(false))
    }
    React.useEffect(init, [ref.current])
    return <FormControl
        onChange={onChange}
        disabled={loading}
        ref={ref}
        as="select">
        <option selected disabled value="">Selecione o IPI</option>
        {
            data.map((ipi, idx) => {
                return <option
                    value={ipi.id}
                    selected={props.selected === ipi.id}
                    key={`select-ipi-${ipi.id}${idx}`}>{ipi.name}</option>
            })
        }
    </FormControl>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/IPI/index.jsx